import { useContext } from 'react'
import { AuthContext } from '../context/auth'

/**
 * ユーザーのサインイン状態を取得するためのカスタムフック。
 * userは読み込み中はundefined, 読み込んだ結果ログインしていない場合はnull
 */
export const useAuthState = () => useContext(AuthContext)
